// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xScreen } from "@awc/XDL/Utilities";
import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

sortSelectStyles.select = {
    sizeVariant: "small",
    labelProps: {
        weight: fontConfig.weight.bold,
        css: css`
            text-transform: none;
            &:after {
                content: ":";
            }
        `,
    },
    iconProps: {
        css: css`
            padding: 8px;
        `,
    },
    cssOverrides: {
        formField: css`
            width: 209px;
        `,
        formInputWrapper: css`
            flex-grow: 1;
            ${xScreen("lte", "md")} {
                width: 100%;
            }
        `,
    },
    css: css`
        &&&& {
            padding-right: 22px;
            -webkit-box-orient: unset;
            &[aria-expanded="true"] ~ ${IconWrapper} {
                padding-left: 8px;
            }
        }
    `,
};
